module.exports = __webpack_public_path__ + "static/media/flag_cy.6cff1088.svg";